import React, { ReactNode } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import classNames from 'classnames';

import './HorizontalLocalMenu.scss';

export type IHorizontalLocalMenuProps = {
  children: ReactNode[];
  classes: string;
  defaultActiveKey: string;
};

const HorizontalLocalMenu = ({
  children,
  classes,
  defaultActiveKey,
}: IHorizontalLocalMenuProps) => (
  <div className={classNames('HorizontalLocalMenu', classes)}>
    <Tabs defaultActiveKey={defaultActiveKey}>{children}</Tabs>
  </div>
);

export { HorizontalLocalMenu, Tab };
